module.exports = __webpack_public_path__ + "primeicons.71bb3d79.woff";